'use client'

import { Typography } from 'antd'

const { Text } = Typography

type TruncatedIdProps = {
  id: string
}

const TruncatedId = ({ id }: TruncatedIdProps) => {
  if (!id) {
    return null
  }

  // 如果ID长度较短（<=15个字符），直接显示完整ID
  if (id.length <= 15) {
    return (
      <Text
        copyable={{ text: id }}
        ellipsis={{ tooltip: id }}
        style={{ display: 'inline-block', maxWidth: '200px' }}>
        {id}
      </Text>
    )
  }

  // 后面固定6个字符
  const suffixCount = 8
  const start = id.slice(0, suffixCount)
  const suffix = `...${id.slice(-suffixCount)}`

  return (
    <Text
      copyable={{ text: id }}
      ellipsis={{ suffix, tooltip: id }}
      style={{ display: 'inline-block', maxWidth: '200px' }}>
      {start}
    </Text>
  )
}

export default TruncatedId
